import { useFeatureGates } from '@office-start/feature-gates-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_LOW_PRIORITY, IDLE_VERYLOW_PRIORITY, } from '@office-start/scheduler-service';
import React, { lazy, useMemo } from 'react';
var LazyWebVitalsButton = lazy(function () {
    return import(
    /*webpackChunkName: "diagnostics-component" */ '@office-start/diagnostics-component');
});
export var WebVitalsButton = function () {
    var _a, _b, _c, _d;
    var featureGates = useFeatureGates().data;
    var isIdleVeryLowPriorityLoad = ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.idleVeryLowPriorityLoadGates) === null || _b === void 0 ? void 0 : _b.idleVeryLowPriorityLoadEnabled) || false;
    var WebVitalsButtonLazy = useMemo(function () {
        var _a, _b;
        return withLazyErrorBoundary(LazyWebVitalsButton, 'DiagnosticsComponent', {
            disabled: !((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.diagnosticsComponentGates) === null || _b === void 0 ? void 0 : _b.diagnosticsComponentEnabled),
            schedulePriority: isIdleVeryLowPriorityLoad
                ? IDLE_VERYLOW_PRIORITY
                : IDLE_LOW_PRIORITY,
        });
    }, [
        (_d = (_c = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _c === void 0 ? void 0 : _c.diagnosticsComponentGates) === null || _d === void 0 ? void 0 : _d.diagnosticsComponentEnabled,
    ]);
    return React.createElement(WebVitalsButtonLazy, null);
};
//# sourceMappingURL=WebVitalsButton.js.map